import styled from "styled-components";
import { Main } from "../../globalStyles/Containers";

export const Container = styled(Main)`
  flex-grow: 1;
`;
